import React from 'react';
import { Th } from '../../../../components/Tbl';

const RowHeader = props => (
  <tr>
    <Th>No.</Th>
    <Th>Order Detail</Th>
    <Th>Rack</Th>
    <Th>Total Price</Th>
    <Th>Payment</Th>
    <Th>Status</Th>
    <Th>Updated</Th>
    <Th>Action</Th>
  </tr>
)

export default RowHeader;